import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export const money = (v) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: v % 1 ? 2 : 0 }).format(v || 0);

const usePageContent = () => {
    const [content, setContent] = useState(null);
    useEffect(() => { api.get('/page-content').then((r) => setContent(r.data)); }, []);
    return content;
};

export default usePageContent;
